import { defaultScheduler, notifyManager } from '@tanstack/react-query';

/**
 * Run a cache write with query observer notifications flushed synchronously.
 *
 * TanStack schedules notifications through `setTimeout(0)`, so a write made while
 * handling an event reaches React a task later (measured: ~18ms). That is too late
 * for drag-and-drop: dnd-kit measures the dragged node to pick the drop animation's
 * landing rect during the same commit that ends the drag, so it would capture the
 * pre-reorder layout and animate the overlay back to the slot the item just left.
 *
 * Flushing inside the event puts the reordered list and dnd-kit's drag teardown in
 * one commit, so the animation lands on the item's new slot.
 *
 * Only needed for writes made from a drop handler — everywhere else the default
 * batching is preferable.
 */
export function writeQueryDataSync(write: () => void): void {
  notifyManager.setScheduler((callback) => callback());
  try {
    write();
  } finally {
    notifyManager.setScheduler(defaultScheduler);
  }
}
